import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { RoutingHelper } from '../../../util/routingHelper'
import LazyFilterOverlay from '../../LazyFilterOverlay/LazyFilterOverlay'

const FilterRoute = ({ history, setCurrentMobileFilter, pclnExpt }) => {
  const [routingHelper] = useState(new RoutingHelper(history))

  function handleClose() {
    setCurrentMobileFilter('')
    routingHelper.goToListings()
  }

  return <LazyFilterOverlay pclnExpt={pclnExpt} onClose={handleClose} />
}

FilterRoute.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  setCurrentMobileFilter: PropTypes.func.isRequired,
  pclnExpt: PropTypes.object,
}

export { FilterRoute }
